import {
	useDateFormat,
	type UseDateFormatReturn
} from "@vueuse/core";

export const weddingDateStores = () => {
	// Anchored to an explicit UTC instant so the date is unambiguous regardless of
	// which timezone the server or the viewer's browser is in.
	const weddingDate = useState<Date>( "wedding-date", () => new Date( Date.UTC( 2027, 4, 29 ) ) );
	// useDateFormat reads local Date getters (getFullYear/getMonth/getDate), so this
	// shifts the instant by the viewer's own UTC offset before formatting - that way
	// the local getters land back on the correct UTC calendar date in every timezone.
	const weddingDateDisplay = useState<Date>( "wedding-date-display", () => new Date( weddingDate.value.getTime() + weddingDate.value.getTimezoneOffset() * 60000 ) );
	const weddingDateFormatted = useState<UseDateFormatReturn>( "wedding-date-formatted", () => useDateFormat( weddingDateDisplay.value, "dddd, MMMM D, YYYY" ) );
	const daysUntilWedding = useState<number>( "days-until-wedding", () => Math.ceil( ( weddingDate.value.getTime() - new Date().getTime() ) / ( 1000 * 60 * 60 * 24 ) ) );

	return {
		weddingDate,
		weddingDateDisplay,
		weddingDateFormatted,
		daysUntilWedding
	};
};